module.exports = __webpack_public_path__ + "static/media/effet2.b085d3f1.ogg";